import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37912296"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sales-report" }
const _hoisted_2 = { class: "report-header radius-7" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h5", { class: "mb-1 fw-bold" }, "Relatórios de vendas"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-muted fs-14" }, "Acompanhe faturamento, produtos, vendedores e projeção mensal.")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "report-loading radius-7"
}
const _hoisted_5 = { class: "report-cards" }
const _hoisted_6 = { class: "report-card radius-7" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total vendido", -1))
const _hoisted_8 = { class: "report-card radius-7" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Vendas concluídas", -1))
const _hoisted_10 = { class: "report-card radius-7" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ticket médio", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Por venda concluída", -1))
const _hoisted_13 = { class: "report-card radius-7" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Produtos vendidos", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Itens movimentados", -1))
const _hoisted_16 = { class: "report-card radius-7 report-card--highlight" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Projeção do mês", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Baseada no ritmo atual", -1))
const _hoisted_19 = { class: "report-grid" }
const _hoisted_20 = { class: "report-panel radius-7" }
const _hoisted_21 = { class: "report-panel-header" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Vendas por dia", -1))
const _hoisted_23 = {
  key: 0,
  class: "daily-chart"
}
const _hoisted_24 = { class: "daily-bar-track" }
const _hoisted_25 = {
  key: 1,
  class: "report-empty"
}
const _hoisted_26 = { class: "report-panel radius-7" }
const _hoisted_27 = { class: "report-panel-header" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Produtos mais vendidos", -1))
const _hoisted_29 = {
  key: 0,
  class: "ranking-list"
}
const _hoisted_30 = {
  key: 1,
  class: "report-empty"
}
const _hoisted_31 = { class: "report-panel radius-7" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report-panel-header" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Ranking de vendedores"),
  /*#__PURE__*/_createElementVNode("span", null, "Por faturamento")
], -1))
const _hoisted_33 = {
  key: 0,
  class: "ranking-list"
}
const _hoisted_34 = {
  key: 1,
  class: "report-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMonth) = $event)),
        type: "month",
        class: "form-control report-month-input radius-7",
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadReport && _ctx.loadReport(...args)))
      }, null, 544), [
        [_vModelText, _ctx.selectedMonth]
      ])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Carregando relatório... "))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("strong", null, _toDisplayString(_ctx.money(_ctx.summary.total_sold)), 1),
              _createElementVNode("small", {
                class: _normalizeClass(_ctx.growthClass)
              }, _toDisplayString(_ctx.growthLabel), 3)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("strong", null, _toDisplayString(_ctx.summary.completed_sales_count || 0), 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.summary.canceled_sales_count || 0) + " canceladas", 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("strong", null, _toDisplayString(_ctx.money(_ctx.summary.average_ticket)), 1),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("strong", null, _toDisplayString(_ctx.summary.products_sold_count || 0), 1),
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("strong", null, _toDisplayString(_ctx.money(_ctx.summary.projected_total)), 1),
              _hoisted_18
            ])
          ]),
          _createElementVNode("section", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("span", null, _toDisplayString(_ctx.dailySales.length) + " dias com venda", 1)
              ]),
              (_ctx.dailySales.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dailySales, (day) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: day.date,
                        class: "daily-bar-row"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatDay(day.date)), 1),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", {
                            class: "daily-bar",
                            style: _normalizeStyle({ width: `${_ctx.barWidth(day.total, _ctx.maxDailyTotal)}%` })
                          }, null, 4)
                        ]),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.money(day.total)), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, "Nenhuma venda concluída neste mês."))
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("span", null, "Top " + _toDisplayString(_ctx.topProducts.length), 1)
              ]),
              (_ctx.topProducts.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topProducts, (product) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: product.product_id,
                        class: "ranking-item"
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", null, _toDisplayString(product.product_name), 1),
                          _createElementVNode("small", null, _toDisplayString(product.sku || '-') + " • " + _toDisplayString(product.quantity) + " un.", 1)
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.money(product.total)), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_30, "Nenhum produto vendido neste mês."))
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              (_ctx.sellerRanking.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sellerRanking, (seller) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: seller.user_id,
                        class: "ranking-item"
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", null, _toDisplayString(seller.user_name), 1),
                          _createElementVNode("small", null, _toDisplayString(seller.sales_count) + " vendas", 1)
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.money(seller.total)), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_34, "Nenhum vendedor com venda neste mês."))
            ])
          ])
        ], 64))
  ]))
}